import React, { useState } from "react";
import HeadCardCandidates from "./HeadCardCandidates";
import ProgressBar from "../ProgressBar";
import { NumericFormat } from "react-number-format";
import { getOverride, getEstimatedVotesPercent } from "../helpers";
/**
 * Displays a single head-to-head card for a given race.
 */
const HeadCard = ({ office, collapsed: initialCollapsed = false, options }) => {
  const [collapsed, setCollapsed] = useState(initialCollapsed);

  const shouldShowImages = office.candidates.every(
    candidate => candidate.image !== ""
  );
  const thereIsAnIncumbent = office.candidates.some(
    candidate => getOverride(candidate, "incumbent") === true
  );

  const thereIsAWinner =
    office.candidates.some(candidate => getOverride(candidate, "winner") === true) &&
    options.showWinner;

  //const officeTitle = getOverride(office, "name");
  //const description = getOverride(office, "description");
  const precinctsReporting = getOverride(office, "precinctsReporting");
  const precinctsTotal = getOverride(office, "precinctsTotal");
  const votesCast = getOverride(office, "votesCast");

  // AP estimated expected vote percentage (eevp), whole number or null when blank. Never calculated; precinctsPercent is not used.
  const reportingPercentage = getEstimatedVotesPercent(office);
  const hasPercent = reportingPercentage !== null;

  return (
    <div className={"widget office" + (collapsed ? " collapsed" : "")}>
      <div
        className="office-title"
        onClick={() => setCollapsed(collapsed => !collapsed)}
      >
        {/* <div className="office-title-name">
          <span>{officeTitle}</span>
        </div> */}
        {/* {options.showVotes && (
          <div className="office-total-label">
            Total Votes{" "}
            <span className="office-total-votes">
              <NumericFormat
                value={votesCast}
                displayType={"text"}
                thousandSeparator={true}
              />
            </span>
          </div>
        )} */}

        {/* {collapsed ? (
          <CollapseIcon className="expand-icon" title="Expand" />
        ) : (
          <ExpandIcon className="expand-icon" title="Collapse" />
        )} */}
      </div>

      {/* {description && (
        <div className="office-description">
          <p>{description}</p>
        </div>
      )} */}

      <div className="candidate-cards">
        <div className="grid-row">
          <HeadCardCandidates
            options={options}
            result={office.candidates}
            votesCast={votesCast}
            shouldShowImages={shouldShowImages}
            thereIsAnIncumbent={thereIsAnIncumbent}
            thereIsAWinner={thereIsAWinner}
          />
        </div>
      </div>

      {options.showPrecincts && (
        <div className="office-precincts-reporting">
          <div className="grid-row">
            <div className="office-precincts-reporting-numbers">
              {options.showTotalPrecincts && (
                <span>
                  <NumericFormat
                    value={precinctsReporting}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                  /
                  <NumericFormat
                    value={precinctsTotal}
                    displayType={"text"}
                    thousandSeparator={true}
                  />{" "}
                  Precincts
                </span>
              )}
              {!options.showTotalPrecincts && (
                <span>Precincts</span>
              )}
            </div>
            {options.showPercentOfPrecincts && hasPercent && (
              <div className="office-precincts-reporting-percentage">
                <span>{reportingPercentage}%</span>
              </div>
            )}
            {options.showPercentOfPrecincts && hasPercent && (
              <div className="office-precincts-reporting-bar">
                <ProgressBar
                  percentage={reportingPercentage}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default HeadCard;
